import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    flex: '1'
  },
  expandIcon: {
    cursor: 'pointer',
    position: 'absolute',
    zIndex: 3,
    left: '9px',
    marginTop: '-30px',
    backgroundColor: '#e5e5e5',
    [theme.breakpoints.down('md')]: {
      width: 20,
      height: 20,
      left: '47%',
      bottom: '-8px',
      backgroundColor: 'transparent',
      outline: 'solid 1px white',
      borderRadius: '1rem'
    }
  },
  typing: {
    display: 'flex',
    marginBottom: 12
  }
}))

export default useStyles
